import useBreakpoint from 'hooks/useBreakpoint';

import JobActionButtons from '../JobActionButtons';

const MobileActionButtons: React.FunctionComponent = function () {
  const underBreakpoint = useBreakpoint(640);
  if (!underBreakpoint) return null;
  return (
    <div className="block sm:hidden w-full bg-neutral-000 sticky bottom-0 px-3 py-4 shadow-lg z-40 border-t border-neutral-200">
      <JobActionButtons />
    </div>
  );
};

export default MobileActionButtons;
